import { SettlementExchangeRateType } from '@g2-shared/api-client/generated/settlement-app';

export const ExchangeRateTypeLabelMapper: Record<SettlementExchangeRateType, string> = {
  [SettlementExchangeRateType.ASK]: 'Ask',
  [SettlementExchangeRateType.BID]: 'Bid',
  [SettlementExchangeRateType.MID]: 'Mid',
  [SettlementExchangeRateType.NONE]: 'None',
};
